import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { MonthOptions, YearOptions } from "../config/functions";
import "../styles/EmployeeReportFilter.css";

interface FilterProps {
  filters: {
    year: string;
    month: string;
    employeeId: string;
  };
  onFilterChange: (filters: {
    year: string;
    month: string;
    employeeId: string;
  }) => void;
  onReset: () => void;
}

const EmployeeSalaryFilter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onReset,
}) => {
  const salaryState = useSelector((state: StoreState) => state.employeeSalary);
  console.log("emp",salaryState);
  

  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const yearOptions = YearOptions().map((opt) => ({
    id: opt.value,
    name: opt.label,
  }));

  const monthOptions = MonthOptions().map((opt) => ({
    id: opt.value,
    name: opt.label,
  }));

  const employeeIds = salaryState
  .filter((item) => {
    const itemYear = String(item.year);
    const itemMonth = (item.month);

    return (
      (!localFilters.year || itemYear === localFilters.year) &&
       (!localFilters.month || String(item.month).padStart(2, "0") === localFilters.month)
    );
  })
  .map((s) => s.employeeId)
  .filter((id, index, self) => id && self.indexOf(id) === index);

  const handleInputChange = (name: string, value: string) => {
    const updatedFilters = {
      ...localFilters,
      [name]: value,
      ...(name === "year" || name === "month" ? { employeeId: "" } : {}),
    };

    setLocalFilters(updatedFilters);
  };
  const uniqueEmployeeIds = employeeIds.map((id) => ({
  id,
  name: id.toString(),
}));
  const renderDropdown = (
    label: string,
    name: string,
    value: string,
    options: { id: string; name: string }[],
  ) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Select
        value={value}
        onChange={(e) => handleInputChange(name, e.target.value)}
        className="custom-select"
      >
        <option value="">All</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );

  return (
    <Form className="task-filter-form">
      <Row className="g-2 align-items-end">
        {renderDropdown("Year", "year", localFilters.year, yearOptions)}
        {renderDropdown("Month", "month", localFilters.month, monthOptions)}
        {renderDropdown(
          "Employee ID",
          "employeeId",
          localFilters.employeeId,
          uniqueEmployeeIds,
        )}

        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="mr-2"
            onClick={() => onFilterChange(localFilters)}
          >
            Find
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default EmployeeSalaryFilter;
